module.exports = __webpack_public_path__ + "static/media/brum.ff43e1ea.mp4";